import { routeNames } from 'src/modules/core/constants/routeNames'

/** After Active Reminders (1), before Unset Appointments (3) per UI D9. */
export const AUTO_ACTIVATED_REMINDERS_DASHBOARD_TAB_INDEX = 2

export function parseDashboardTabIndexFromSearchParams(searchParams: URLSearchParams, tabCount: number): number {
  const rawTab = searchParams.get('tab')
  if (rawTab == null) {
    return 0
  }

  const tabIndex = Number(rawTab)
  if (!Number.isInteger(tabIndex) || tabIndex < 0 || tabIndex >= tabCount) {
    return 0
  }

  return tabIndex
}

export function buildDashboardTabPath(tabIndex: number): string {
  return `${routeNames.dashboard.path}?tab=${tabIndex}`
}

export function buildAutoActivatedRemindersDashboardPath(): string {
  return buildDashboardTabPath(AUTO_ACTIVATED_REMINDERS_DASHBOARD_TAB_INDEX)
}
